import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';

import { AppConfigService } from 'app/services/app-config/app-config.service';
import { AuthenticationService } from '../authentication/authentication.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { WarningService } from '../warning/warning.service';
import { landingUrl } from 'environments/properties';
import { Language } from 'app/model/constant';

@Injectable()
export class AuthenticationGuard implements CanActivate {

  constructor(
    private authService: AuthenticationService,
    private warningService: WarningService,
    private appConfigService: AppConfigService,
    private router: Router
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    return this.authService.validateToken(this.authService.getToken()).map(result => {
      if (!result) {
        const userInfo = this.authService.getUserInfo();
        this.authService.clearToken();
        if (userInfo && userInfo.companyCode) {
          this.warningService.popDialogErrorRequest('popup-warning-session-expire', null, null, `/company/${userInfo.companyCode}`);
        } else {
          const parseUrl = this.router.parseUrl(state.url);
          delete parseUrl.queryParams['lang'];
          const returnUrl: string = next.queryParams && next.queryParams.returnUrl ? next.queryParams.returnUrl : parseUrl.toString();
          this.appConfigService.setReturnUrl(returnUrl);
          if (this.appConfigService.getLanguage() === Language.th) {
            window.location.href = landingUrl + '/th/index.html';
          } else {
            window.location.href = landingUrl;
          }
        }
      }
      return result;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/guard/authentication.guard.ts